<template>
  <div class="d-flex mt-3 justify-content-end align-items-center pe-5">
    <div class="d-flex gap-4 align-items-center">
      <otp-threshold-slider
        :threshold="thresholdValue"
        :label="`${$t('flexigo.dashboard.delayThreshold')}:`"
        @ready="handleThresholdReady"
        @change="handleThresholdChange"
      />
      <div class="d-flex align-items-center gap-2">
        <multiselect
          v-model="selectedVehicle"
          :options="vehicles"
          :placeholder="$t('flexigo.dashboard.allVehicles')"
          track-by="id"
          label="plate"
          :allowEmpty="true"
          :searchable="true"
          :maxHeight="300"
          :optionsLimit="100"
          class="custom-multiselect"
          @input="onVehicleChange"
        />
      </div>
      <div class="d-flex align-items-center gap-2">
        <multiselect
          v-model="selectedDriver"
          :options="drivers"
          :placeholder="$t('flexigo.dashboard.allDrivers')"
          track-by="fullName"
          label="fullName"
          :allowEmpty="true"
          :searchable="true"
          :maxHeight="300"
          :optionsLimit="100"
          class="custom-multiselect"
          @input="onDriverChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import PlannerServices from '@/modules/Flexigo/services/planner';
import OtpThresholdSlider from '@/modules/Flexigo/components/dashboard/otp/filters/OtpThresholdSlider.vue';

export default {
  name: 'SubChartHeader',
  components: {
    Multiselect,
    OtpThresholdSlider,
  },
  data() {
    return {
      vehicles: [],
      drivers: [],
      selectedVehicle: null,
      selectedDriver: null,
      thresholdValue: null,
    };
  },
  async created() {
    await this.fetchVehicles();
    await this.fetchDrivers();
  },
  methods: {
    handleThresholdReady(value) {
      this.thresholdValue = value;
      this.$emit('threshold-ready', value);
    },
    handleThresholdChange(value) {
      this.thresholdValue = value;
      this.$emit('threshold-change', value);
    },
    async fetchVehicles() {
      try {
        const vehicles = await PlannerServices.getVehicles();
        this.vehicles = vehicles || [];
      } catch (error) {
        console.error('Error fetching vehicles:', error);
      }
    },
    async fetchDrivers() {
      try {
        const drivers = await PlannerServices.getDrivers();
        this.drivers = drivers || [];
      } catch (error) {
        console.error('Error fetching drivers:', error);
      }
    },
    onVehicleChange(vehicle) {
      this.$emit('vehicle-change', vehicle);
    },
    onDriverChange(driver) {
      this.$emit('driver-change', driver);
    },
  },
};
</script>

<style scoped>
.title {
  color: #363647;
  font-weight: bold;
  font-size: 16px;
  margin-bottom: 0;
}

.select-label {
  color: #363647;
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 0;
  white-space: nowrap;
}

.custom-multiselect {
  min-width: 200px;
}

.custom-multiselect ::v-deep .multiselect__tags {
  border: 1px solid #e6eaee;
  border-radius: 4px;
  min-height: 38px;
  padding: 8px 40px 0 8px;
}

.custom-multiselect ::v-deep .multiselect__select {
  height: 38px;
}

.custom-multiselect ::v-deep .multiselect__input {
  font-size: 14px;
}

.custom-multiselect ::v-deep .multiselect__single {
  font-size: 14px;
  margin-bottom: 8px;
}

.custom-multiselect ::v-deep .multiselect__tags:focus-within {
  border-color: #4a90e2;
  box-shadow: 0 0 0 2px rgba(74, 144, 226, 0.1);
}

.custom-multiselect ::v-deep .multiselect__content-wrapper {
  width: 250px !important;
  max-width: 250px !important;
  min-width: 250px !important;
  overflow-x: hidden !important;
}

.custom-multiselect ::v-deep .multiselect__content {
  width: 250px !important;
  max-width: 250px !important;
}

.custom-multiselect ::v-deep .multiselect__element {
  width: 250px !important;
  max-width: 250px !important;
}

.custom-multiselect ::v-deep .multiselect__option {
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  width: 250px !important;
  max-width: 250px !important;
  box-sizing: border-box !important;
  padding-right: 12px !important;
}
</style>
